import { render, staticRenderFns } from "./TimeSlotsPerResource.vue?vue&type=template&id=774baeec&scoped=true"
import script from "./TimeSlotsPerResource.vue?vue&type=script&lang=js"
export * from "./TimeSlotsPerResource.vue?vue&type=script&lang=js"
import style0 from "./TimeSlotsPerResource.vue?vue&type=style&index=0&id=774baeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774baeec",
  null
  
)

export default component.exports